import { Injectable } from '@angular/core';
import { GenericResponse } from 'projects/Autofacets-Core/src/app/business-entities/generic-response.class';
import { DataService } from 'projects/Autofacets-Core/src/app/services/data.service';
import { Urls } from 'projects/Autofacets-Core/src/app/utils/urls';
import { ErrorLogAnalysisRequestModel, ErrorLogOccurrenceRequestModel, ErrorLogStatusUpdateModel } from '../business-entities/error-log-analysis-report.model';

@Injectable({
  providedIn: 'root'
})
export class ErrorLogAnalysisReportDataService {

  constructor(private dataService: DataService) { }

  async getErrorLogAnalysis(requestModel: ErrorLogAnalysisRequestModel): Promise<GenericResponse<any>> {
    return this.dataService.Post<GenericResponse<any>>(Urls.GetErrorLogAnalysis, requestModel).toPromise();
  }

  async updateErrorLogStatus(requestModel: ErrorLogStatusUpdateModel): Promise<GenericResponse<any>> {
    return this.dataService.Post<GenericResponse<any>>(Urls.UpdateErrorLogStatus, requestModel).toPromise();
  }

  async getErrorLogOccurrences(requestModel: ErrorLogOccurrenceRequestModel): Promise<GenericResponse<any>> {
    return this.dataService.Post<GenericResponse<any>>(Urls.GetErrorLogOccurrences, requestModel).toPromise();
  }

}
